import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GenericsService} from './generics.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer OTA2ZmFlM2Y3MWZiZmM1ZmRhMWEzYThmODdiNzU4ODE='
  })
};

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private generics: GenericsService,
    private http: HttpClient) {
  }

  getChat(id_projeto) {
    return this.generics.get('chat/projeto/' + id_projeto);
  }

  setChat(data) {
    return this.generics.post('chat ', JSON.stringify(data));
  }
}
